import { useNavigate, useLocation } from 'react-router-dom';
import GlowButton from '@/components/base/GlowButton';

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f8fb] via-[#f8fafc] to-[#f3f7fa] flex flex-col items-center justify-center px-4 text-center relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#0088CC]/5 pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-48 h-48 rounded-full bg-[#0088CC]/4 pointer-events-none" />

      {/* 404 watermark */}
      <p className="absolute text-[18rem] font-black text-[#0088CC]/5 select-none pointer-events-none leading-none">
        404
      </p>

      {/* Card */}
      <div className="relative z-10 bg-white/55 backdrop-blur-md border border-white/80 rounded-2xl px-10 py-12 max-w-md w-full">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#0088CC]/10 border border-[#0088CC]/20 mx-auto mb-5">
          <i className="ri-map-pin-line text-[#0088CC] text-3xl"></i>
        </div>
        <h1 className="text-2xl font-extrabold text-slate-800 mb-2">Page Not Found</h1>
        <p className="text-sm text-slate-400 mb-1">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <p className="text-xs text-slate-300 font-mono mb-8 truncate">{location.pathname}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <GlowButton
            onClick={() => navigate('/')}
            className="px-6 py-2.5 text-sm font-semibold rounded-xl"
          >
            <i className="ri-home-line text-base"></i>
            Back to Home
          </GlowButton>
          <GlowButton
            onClick={() => navigate(-1)}
            variant="secondary"
            className="px-6 py-2.5 text-sm font-semibold rounded-xl"
          >
            <i className="ri-arrow-left-line text-base"></i>
            Go Back
          </GlowButton>
        </div>
      </div>
    </div>
  );
}
